import { DatePipe, registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieService } from 'ngx-cookie-service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoadingInterceptor } from './shared/interceptors/loading.interceptor';
import { TokenInterceptor } from './shared/interceptors/token.interceptor';
import { SharedModule } from './shared/shared.module';

import localePy from '@angular/common/locales/es-AR';
import { FinanceModule } from './invopay/module/finance/finance.module';
import { DecryptionService } from './shared/services/decryption.service';
import { DecryptionInterceptor } from './shared/interceptors/decryption.interceptor';
import { IpProfileService } from './invopay/services/ip-profile.service';
import { CustomReuseStrategy } from './shared/services/route-reuse.strategy';
import { RouteReuseStrategy } from '@angular/router';
registerLocaleData(localePy, 'es');

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function initConfig(profileService: IpProfileService) {
  return () => {
    return Promise.resolve();
  }    
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    FinanceModule,
    HttpClientModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    CookieService,
    DatePipe,
    DecryptionService,
    IpProfileService,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [IpProfileService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DecryptionInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'es',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    // // Deprecated
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: ErrorInterceptor,
    //   multi: true,
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    { 
      provide: RouteReuseStrategy, 
      useClass: CustomReuseStrategy 
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
